<nav aria-label="breadcrumb">
    <ol class="breadcrumb">
        <li *ngIf="breadcrumbs.length > 0" class="breadcrumb-item">
            <a [routerLink]="getBreadcrumbUrl(0)">{{breadcrumbs[0].Title}}</a>
        </li>
        <li *ngIf="breadcrumbs.length > 2" class="breadcrumb-item">
            <a class="breadcrumb-item-link" [routerLink]="getBreadcrumbUrl(1)">{{breadcrumbs[1].Title}}</a>
        </li>
        <li *ngIf="breadcrumbs.length > 3" class="breadcrumb-item">
            <a class="breadcrumb-item-link" [routerLink]="getBreadcrumbUrl(2)">{{breadcrumbs[2].Title}}</a>
        </li>
        <li *ngIf="breadcrumbs.length > 0" class="breadcrumb-item active">
            {{breadcrumbs[breadcrumbs.length-1].Title}}
        </li>
    </ol>
</nav>